import { defineStore } from 'pinia';
import router from './../router';

const ruta_api = process.env.VUE_APP_ROOT_API;

export const useAuth = defineStore({
  id: 'auth',
  state: () => ({
      token: localStorage.getItem('token') || '',
      user: JSON.parse(localStorage.getItem('user')),
      returnUrl: null
  }),
  actions: {
      // signup user
      async userSignup(data) {
          const res = await fetch('http://localhost:8000/api/register', {
              method: 'POST',
              body: JSON.stringify(data),
              headers: {
                  'Content-Type': 'application/json'
              }
          });
          const output = await res.json();
          if (output.success) {
              alert(output.message);
              data.name = '';
              data.email = '';
              data.password = '';
          } else {
              alert(output.message);
          }
      },

      async userLogin(data) {
          try {
              const res = await fetch(ruta_api + '/login', {
                  method: 'POST',
                  body: JSON.stringify(data),
                  headers: { 'Content-Type': 'application/json' }
              });

              // Manejo de bloqueo por múltiples intentos (throttle)
              if (res.status === 429) {
                  return {
                      success: false,
                      bloqueado: true,
                      mensaje: 'Por seguridad, la cuenta ha sido bloqueada temporalmente por múltiples intentos fallidos. Por favor, intenta de nuevo en 1 minuto.'
                  };
              }

              const output = await res.json();

              // 🛑 INTERCEPCIÓN 2FA: El usuario tiene 2FA activo, pedir el PIN
              if (output.requires_2fa) {
                  return {
                      requires_2fa: true,
                      user_id: output.user_id,
                      mensaje: output.mensaje
                  };
              }

              // FLUJO NORMAL: Login sin 2FA
              if (output.success) {
                  localStorage.setItem('token', output.token);
                  this.token = output.token;
                  this.user = output.user;
                  this.user.permissions = output.permissions;
                  localStorage.setItem('user', JSON.stringify(output.user));
                  router.push(this.returnUrl || '/');
                  return { success: true };
              }

              return {
                  success: false,
                  mensaje: output.mensaje || output.errors || 'Credenciales incorrectas.'
              };

          } catch (error) {
              console.error('Error en el login:', error);
              return { success: false, mensaje: 'Error de conexión. Verifique su red.' };
          }
      },

      // 🔐 Verificar el PIN de 6 dígitos del Google Authenticator
      async verifyLogin2FA(data) {
          try {
              const res = await fetch(ruta_api + '/login/2fa/verificar', {
                  method: 'POST',
                  body: JSON.stringify(data), // { user_id, otp }
                  headers: { 'Content-Type': 'application/json' }
              });

              const output = await res.json();

              if (output.success) {
                  localStorage.setItem('token', output.token);
                  this.token = output.token;
                  this.user = output.user;
                  this.user.permissions = output.permissions;
                  localStorage.setItem('user', JSON.stringify(output.user));
                  router.push(this.returnUrl || '/');
                  return { success: true };
              }

              return {
                  success: false,
                  mensaje: output.mensaje || 'Código incorrecto. Intente nuevamente.'
              };

          } catch (error) {
              console.error('Error validando 2FA:', error);
              return { success: false, mensaje: 'Error de conexión. Verifique su red.' };
          }
      },

      async getUser() {
          const res = await fetch('http://localhost:8000/api/user', {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + localStorage.getItem('token')
              }
          });
          const output = await res.json();
          this.user = output.user;
      },

      userLogout() {
          this.token = '';
          this.user = '';
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          router.push({ name: 'login' });
      }
  }
})